export var DEPLOY_DATE = new Date('2026-09-30T09:19:55+0000');
